import { useMemo } from 'react';
import { ExportReportType } from '~/exportReport/exportReportType';
import type { ReportTableColumn } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

export const EXPORT_REPORT_LOCATION_RADIUS_TABLE_COLUMNS = [{
  id: 'radius5',
  heading: '5km',
  secondaryHeading: 'Radius Circle',
}, {
  id: 'radius10',
  heading: '10km',
  secondaryHeading: 'Radius Circle',
}, {
  id: 'radius15',
  heading: '15km',
  secondaryHeading: 'Radius Circle',
}] as const satisfies ReadonlyArray<ReportTableColumn>;

export const useExportReportParams = () => {
  const exportReportState = useToolsStateExportReportSelector();

  const tableColumns = useMemo<ReadonlyArray<ReportTableColumn>>(() => {
    if (!exportReportState.isActive) {
      return [];
    }

    switch (exportReportState.params.type) {
      case ExportReportType.Location:
        return EXPORT_REPORT_LOCATION_RADIUS_TABLE_COLUMNS;
      case ExportReportType.Radius: {
        return [{
          id: 'radius',
          heading: `${exportReportState.params.data.radius / 1000}km`,
          secondaryHeading: 'Radius Circle',
        }];
      }

      case ExportReportType.DriveTimePolygon: {
        return [{
          id: 'dtp',
          heading: `${exportReportState.params.data.minutes} min`,
          secondaryHeading: 'DT Polygon',
        }];
      }

      case ExportReportType.Boundary: {
        return [{
          id: 'boundary',
          heading: exportReportState.params.data.boundaryName,
          secondaryHeading: 'Boundary',
        }];
      }

      default: {
        return [];
      }
    }
  }, [exportReportState]);

  return { tableColumns };
};
